import _get from 'lodash/get';
import store from '@/store';

export default () => {
  const permissions = _get(store, 'state.user.user.permissions', []);
  return permissions.reduce((result, item) => {
    result[item] = true;
    return result;
  }, {});
};
